import React, { useContext, useEffect, useState } from "react";
import { CcRootContext } from "../conversionCenterRoot";
import CcHeader from "../elements/ccHeader";
import CcLoader from "../elements/ccLoader";
import * as Types from "../elements/types";
import { getArrayLastItem } from "../helpers/helpers";

const ElementScreen = ({ defaultScreen = null }) => {
  const ctx = useContext(CcRootContext);
  const current = defaultScreen || getArrayLastItem(ctx.history);
  const [elementScreenData, setElementScreenData] = useState(null);
  
  useEffect(() => {
    setElementScreenData(
      ctx.sites
        .find((site) => site.specialtyName === current.activeSpecialty).elements
        .find((element) => element.numberInOrder === current.activeElementPosition)
    );
  }, [ctx.sites, current.activeElementPosition, current.activeSpecialty]);

  const CurrentType = elementScreenData && Types[elementScreenData.type];

  return(
    elementScreenData ? (
      <>
        <CcHeader 
          details={elementScreenData.details}
          video={elementScreenData.video}
          showDetails={elementScreenData?.type !== "Video"}
          defaultScreen={defaultScreen}
        />
        <CurrentType items={elementScreenData.items} defaultScreen={defaultScreen} preview={ctx?.preview} uuid={ctx?.attributes.uuid} draftId={ctx?.draftId} />
      </>
    ) : <CcLoader />
  );
};

export default ElementScreen;
